<template>

<div>
	
    <div id="modal_codes" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">Koder</h4>
                </div>
                <div class="modal-body">


                    <div v-for="code in codes">
                        <input type="checkbox" disabled="disabled" v-bind:checked="code.punched == 1" />
                        {{ code.code }}

                        <span v-if="code.punched == 1">
                            Använd: {{ code.updated_at }}
                        </span>

                    </div> 

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Stäng</button>
                </div>
            </div>
        </div>
    </div>

</div>

</template>


<script>
    
    /*
    import datepicker from './../datepicker/Datepicker.vue'
    Vue.component('datepicker', datepicker);
    */

    export default {



        props: {
            activeCard: {

            },

            customer: {

            }
	    },

	    data: function() {

            return {

                test: {},

                date_format: 'yyyy-MM-dd',

            	signature_key: null,
                treatment_date: null,

                response: null,

                mode: 'validate',

                alerts: {
                    error: false,
                    confirm: false,
                    complete: false,
                }
                
            }

        },
        computed: {

            codes: function() {

                if(this.activeCard == null) {
                    return null
                } 

                return this.activeCard.manual_punches;


            }

        },
	    methods: {

            selectDate: function(date) {

                this.treatment_date = date;
            }

	    },
        watch : {
            
        }

    }
</script>

